import ProjectSubCategoryModel from 'models/ProjectSubCategoryModel';
import BudgetAggregate         from 'models/budgetModels/BudgetAggregateModel';

export default class ProjectSubCategoryBudgetModel extends BudgetAggregate(ProjectSubCategoryModel) {
	static get path(): string {
		return '/project_sub_categories/_budget';
	}
}
